/** Vendored Feedback entities v3 compositions. Geometry stays in the CSS module. */
export const WORKSPACE_ART = {
  "customers": {
    "layout": "gather",
    "objects": [
      "queue-customer-blue",
      "queue-customer-lavender",
      "queue-customer-coral"
    ]
  },
  "jobs": {
    "layout": "stack",
    "objects": [
      "queue-job-green",
      "queue-customer-blue",
      "queue-job-aqua"
    ]
  },
  "invoices": {
    "layout": "stack",
    "objects": [
      "queue-invoice-yellow",
      "queue-invoice-coral",
      "queue-customer-blue"
    ]
  },
  "meetings": {
    "layout": "calendar",
    "objects": [
      "queue-customer-blue",
      "queue-reminder-coral",
      "queue-meeting-aqua"
    ]
  },
  "messages": {
    "layout": "conversation",
    "objects": [
      "queue-text-aqua",
      "queue-text-lavender",
      "queue-customer-blue"
    ]
  },
  "calls": {
    "layout": "orbit",
    "objects": [
      "queue-call-coral",
      "queue-text-aqua",
      "queue-customer-blue"
    ]
  },
  "reminders": {
    "layout": "gather",
    "objects": [
      "queue-reminder-coral",
      "queue-reminder-yellow",
      "kinds-note-pink"
    ]
  },
  "notifications": {
    "layout": "orbit",
    "objects": [
      "queue-notification-lavender",
      "queue-text-aqua",
      "queue-update-yellow"
    ]
  },
  "team": {
    "layout": "gather",
    "objects": [
      "queue-team-blue",
      "queue-customer-green",
      "queue-customer-lavender"
    ]
  },
  "accounts": {
    "layout": "gather",
    "objects": [
      "queue-account-blue",
      "queue-account-lavender",
      "queue-account-coral"
    ]
  },
  "updates": {
    "layout": "orbit",
    "objects": [
      "queue-update-yellow",
      "queue-notification-lavender",
      "queue-text-aqua"
    ]
  },
  "forms": {
    "layout": "stack",
    "objects": [
      "kinds-md-navy",
      "kinds-note-pink",
      "queue-customer-blue"
    ]
  },
  "history": {
    "layout": "orbit",
    "objects": [
      "queue-call-coral",
      "queue-text-aqua",
      "queue-invoice-yellow"
    ]
  },
  "queue": {
    "layout": "gather",
    "objects": [
      "queue-job-green",
      "queue-invoice-yellow",
      "queue-reminder-coral"
    ]
  },
  "home": {
    "layout": "orbit",
    "objects": [
      "queue-customer-blue",
      "queue-job-green",
      "queue-invoice-yellow"
    ]
  },
  "calendar": {
    "layout": "calendar",
    "objects": [
      "queue-reminder-coral",
      "queue-customer-blue",
      "queue-job-green"
    ]
  },
  "money": {
    "layout": "stack",
    "objects": [
      "queue-invoice-green",
      "queue-invoice-yellow",
      "queue-job-green"
    ]
  },
  "reports": {
    "layout": "stack",
    "objects": [
      "kinds-md-navy",
      "queue-invoice-green",
      "queue-job-green"
    ]
  },
  "memory": {
    "layout": "folder",
    "objects": [
      "kinds-folder-open-blue",
      "kinds-note-pink",
      "kinds-pdf-red"
    ]
  },
  "aria": {
    "layout": "conversation",
    "objects": [
      "destinations-aria-light-active",
      "queue-text-aqua",
      "queue-customer-blue"
    ]
  },
  "search": {
    "layout": "orbit",
    "objects": [
      "queue-customer-blue",
      "queue-job-green",
      "queue-invoice-yellow"
    ]
  },
  "services": {
    "layout": "stack",
    "objects": [
      "queue-job-green",
      "kinds-md-navy",
      "queue-job-aqua"
    ]
  },
  "files": {
    "layout": "folder",
    "objects": [
      "kinds-folder-open-blue",
      "kinds-image-teal",
      "kinds-pdf-red"
    ]
  },
  "payments": {
    "layout": "conversation",
    "objects": [
      "queue-invoice-yellow",
      "queue-customer-blue",
      "queue-text-aqua"
    ]
  },
  "notes": {
    "layout": "stack",
    "objects": [
      "kinds-note-pink",
      "kinds-md-navy",
      "queue-customer-blue"
    ]
  },
  "trash": {
    "layout": "folder",
    "objects": [
      "kinds-trash-gray",
      "kinds-note-pink",
      "kinds-folder-open-blue"
    ]
  }
} as const

export type WorkspaceArtKind = keyof typeof WORKSPACE_ART
